import { render, staticRenderFns } from "./SettlementPayments.vue?vue&type=template&id=49c327c8&scoped=true"
import script from "./SettlementPayments.vue?vue&type=script&lang=js"
export * from "./SettlementPayments.vue?vue&type=script&lang=js"
import style0 from "./SettlementPayments.vue?vue&type=style&index=0&id=49c327c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c327c8",
  null
  
)

export default component.exports